// extracted by mini-css-extract-plugin
module.exports = {"card":"card__uGrf-","cardHeader":"cardHeader__k6RS9","cardHeaderBorder":"cardHeaderBorder__ZoGPk","cardPairing":"cardPairing__WJEOK","cardLoader":"cardLoader__eCQDs"};